// src/pages/couriers/components/AssignModal.jsx
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import { Plus, X, RefreshCw, Truck, Phone, Mail } from 'lucide-react';
import styles from './AssignModal.module.css';

const AssignModal = ({
  isOpen,
  onClose,
  availableCouriers,
  selectedCourierIds,
  onToggleSelection,
  onAssign,
  isSubmitting
}) => {
  const { t } = useLocalization();

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>
            <Plus size={20} />
            {t('couriers.assignModalTitle')}
          </h2>
          <button onClick={onClose} className={styles.closeButton}>
            <X size={20} />
          </button>
        </div>

        <div className={styles.modalContent}>
          <p className={styles.modalDescription}>
            {t('couriers.assignModalDescription')}
          </p>

          <div className={styles.courierSelectionList}>
            {availableCouriers.length === 0 ? (
              <div className={styles.emptyState}>
                <Truck size={48} />
                <p>{t('couriers.noCouriersAvailable')}</p>
              </div>
            ) : (
              availableCouriers.map(courier => (
                <div
                  key={courier.id}
                  className={`${styles.courierSelectionItem} ${
                    selectedCourierIds.includes(courier.id) ? styles.selected : ''
                  }`}
                  onClick={() => onToggleSelection(courier.id)}
                >
                  <div className={styles.courierCheckbox}>
                    <input
                      type="checkbox"
                      checked={selectedCourierIds.includes(courier.id)}
                      onChange={() => {}}
                      className={styles.checkbox}
                    />
                  </div>
                  <div className={styles.courierInfo}>
                    <div className={styles.courierName}>{courier.name}</div>
                    {courier.description && (
                      <div className={styles.courierDescription}>{courier.description}</div>
                    )}
                    {courier.contactInfo && (
                      <div className={styles.courierContact}>
                        {courier.contactInfo.phone && (
                          <span>
                            <Phone size={12} />
                            {courier.contactInfo.phone}
                          </span>
                        )}
                        {courier.contactInfo.email && (
                          <span>
                            <Mail size={12} />
                            {courier.contactInfo.email}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            onClick={onClose}
            className={styles.secondaryButton}
            disabled={isSubmitting}
          >
            {t('couriers.cancel')}
          </button>
          <button
            onClick={onAssign}
            className={styles.primaryButton}
            disabled={isSubmitting || selectedCourierIds.length === 0}
          >
            {isSubmitting ? (
              <>
                <RefreshCw size={16} className={styles.spinning} />
                {t('couriers.assigning')}
              </>
            ) : (
              <>
                <Plus size={16} />
                {t('couriers.assign')} {selectedCourierIds.length > 0 ? `(${selectedCourierIds.length})` : ''}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignModal;